var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{style:({ fill: 'none !important' }),attrs:{"width":"12","height":"9","viewBox":"0 0 12 9","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 1L4.33333 8L1 5","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }